var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwygLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5245 27.8475C25.5245 28.7495 25.7607 29.458 26.2277 29.9658C26.7 30.4701 27.3126 30.7222 28.0743 30.7222C29.1238 30.7222 30.0453 30.4541 30.8426 29.909L33.7706 38.4303C31.9293 39.4744 29.4114 40 26.2294 40C22.0709 40 18.8712 39.0003 16.6267 36.9921C14.3823 34.9838 13.2637 31.9705 13.2637 27.9576V23.6374C13.2637 20.8461 15.5258 18.5839 18.3172 18.5839H22.2094C23.4772 18.5839 24.6331 18.0885 25.4855 17.2788C25.5139 17.2504 25.5458 17.2184 25.5796 17.19C26.4407 16.3235 26.9734 15.1374 26.9734 13.8199C26.9734 12.5023 26.3999 11.2221 25.4855 10.352C24.6314 9.54233 23.4772 9.05047 22.2094 9.05047H18.3172C15.5258 9.05047 13.2637 6.7883 13.2637 3.99698V0H25.4855V3.20327C25.4855 6.43139 28.0992 9.05047 31.3327 9.05047C32.6413 9.05047 33.8701 9.58672 34.7685 10.4497C35.6706 11.3109 36.2405 12.5023 36.2441 13.8128C36.2441 15.1338 35.7114 16.3253 34.8413 17.1918C33.9837 18.053 32.7887 18.5857 31.4712 18.5857H31.4055C28.1738 18.5857 25.5583 21.2048 25.5583 24.4329L25.5263 27.8492L25.5245 27.8475Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81183 18.7064C12.5243 18.7064 14.7233 16.5075 14.7233 13.795C14.7233 11.0825 12.5243 8.88354 9.81183 8.88354C7.09932 8.88354 4.90039 11.0825 4.90039 13.795C4.90039 16.5075 7.09932 18.7064 9.81183 18.7064Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwygLogoIcon);
export default __webpack_public_path__ + "static/media/twyg-logo-icon.990e8999eabb281166c501de90c4ab3f.svg";
export { ForwardRef as ReactComponent };